import React, { useState } from 'react'
import { usePostHog } from 'posthog-js/react'

const imgSparkles = '/icon/sparkles.svg'
const imgFrame2147229023 = 'https://www.figma.com/api/mcp/asset/d7b67e05-31aa-485c-8dd4-4b4f97244c00'
const imgFrame2147229024 = 'https://www.figma.com/api/mcp/asset/b70427f9-28b7-40bc-86d1-c4f775d6d673'
const imgFrame2147229025 = 'https://www.figma.com/api/mcp/asset/661035e7-0f09-4291-92ce-0f31634ae920'
const imgFrame2147229026 = 'https://www.figma.com/api/mcp/asset/a80b7c2e-e00d-43d6-b28a-56152fb25f38'
const imgFrame2147229027 = 'https://www.figma.com/api/mcp/asset/2a155cfc-e6c0-4cb0-8bc8-ce2a8b16d312'
const imgDownload02 = 'https://www.figma.com/api/mcp/asset/d482fec7-ac1d-454d-bd12-fcb21cca6466'
const imgBubbleChatAdd = 'https://www.figma.com/api/mcp/asset/c4fcf724-12b0-4bdc-99bd-365a09e329f8'
const imgSettings01 = 'https://www.figma.com/api/mcp/asset/4de021c3-868f-4d7f-a186-03baf9fd6001'
const imgSearch01 = 'https://www.figma.com/api/mcp/asset/7dc166d0-a3c0-443a-95b1-dc9cdffb2152'
const imgFilter = 'https://www.figma.com/api/mcp/asset/c6a73ec5-5683-4627-a7d3-49775113562f'
const imgTickDouble = 'https://www.figma.com/api/mcp/asset/63117ca1-cf79-407e-96b7-59ea3a1a8345'
const imgTickDoubleAlt = 'https://www.figma.com/api/mcp/asset/09ab5c34-8334-488f-9a0a-2f69759f7cc2'
const imgEllipse474 = 'https://www.figma.com/api/mcp/asset/13870f29-d874-4a29-83a9-0c615178bd9b'
const imgEllipse478 = 'https://www.figma.com/api/mcp/asset/fd7538f3-fb5a-4b0d-bb8a-a03392ed3a72'
const imgEllipse475 = 'https://www.figma.com/api/mcp/asset/1700850d-370c-41e1-bf32-d0d7c579630c'
const imgEllipse477 = 'https://www.figma.com/api/mcp/asset/ba968e77-0546-4de9-971f-a6f0e814a382'
const imgEllipse476 = 'https://www.figma.com/api/mcp/asset/4b43ec6b-a92f-4aa9-809f-6ea7040e4e65'
const imgEllipse479 = 'https://www.figma.com/api/mcp/asset/08292b94-7811-4fee-917d-b93cc4181923'
const imgEllipse480 = 'https://www.figma.com/api/mcp/asset/eaac8271-0d3c-48ca-b807-26107fda1000'
const imgEllipse481 = 'https://www.figma.com/api/mcp/asset/ea6bcd0a-7486-41e4-bee4-43dfc5d787bd'
const imgGroup = 'https://www.figma.com/api/mcp/asset/7f952b74-2857-4c7c-9318-88e9f84512e9'
const imgSymbolSvg = 'https://www.figma.com/api/mcp/asset/9a5f2004-3f95-4236-a4f5-36cb2dd2990e'
const imgFlash = 'https://www.figma.com/api/mcp/asset/edac8914-9028-4724-ba59-ea9ff37b1c66'
const imgMageDots = 'https://www.figma.com/api/mcp/asset/c86b0e69-b527-492d-948d-607c4b3c0eda'
const imgMynauiChevronUp = 'https://www.figma.com/api/mcp/asset/c2f45586-ed6d-4de9-802b3c91a739'
const imgMynauiChevronUpAlt = 'https://www.figma.com/api/mcp/asset/021177fe-99ac-430c-94e6-5473b8c06d23'
const imgPlusSign = 'https://www.figma.com/api/mcp/asset/f87f0b1e-9bac-42ff-818c-dfb43eb8373e'
const imgGroup1171275032 = 'https://www.figma.com/api/mcp/asset/4c06898d-83df-4252-988b-ab63eadefbfe'
const imgTablerMessageFilled = 'https://www.figma.com/api/mcp/asset/24f7b654-8286-4bdb-ada2-effd7848c793'
const imgSolarAtomBold = 'https://www.figma.com/api/mcp/asset/731a78b8-3ab9-42fb-89d6-3054e87ccc45'
const imgRiAppsFill = '/icon/mobile-apps.svg'
const imgFluentPeopleTeam32Filled = '/icon/team-management.svg'
const imgGroup1 = '/icon/ai-assisted-replies.svg'
const imgBubbleChat = '/icon/bubble-chat.svg'
const imgBot = '/icon/bot.svg'
const imgMessageMultiple01 = '/icon/message-multiple-01.svg'
const imgChart01 = '/icon/chart-01.svg'
const imgUserMultiple02 = '/icon/user-multiple-02.svg'
const imgSmartPhone02 = '/icon/smart-phone-02.svg'
const imgRefreshDot = '/icon/refresh-dot.svg'
const imgCustomerService02 = '/icon/customer-service-02.svg'
const imgTimer02 = '/icon/timer-02.svg'
const imgFile01 = '/icon/file-01.svg'
const imgTag = '/icon/discount-tag-02.svg'
const imgClock = '/icon/timer-02.svg'
const imgDownload = '/icon/package-open.svg'
const imgHeadphones = '/icon/customer-service-02.svg'
const imgWhatsapp = '/icon/whatsapp.svg'

const Features = () => {
  const [isExpanded, setIsExpanded] = useState(false)
  const posthog = usePostHog()

  const chats = [
    {
      name: 'Allison Brooke',
      time: '12:33 PM',
      text: 'Can you change the icon here to any...',
      tags: ['Human Support'],
      avatar: imgFrame2147229023,
    },
    {
      name: 'Thomas Jake',
      time: '19/10/2025',
      text: "You're welcome! I'm glad I could help...",
      avatar: imgFrame2147229024,
      unread: true,
    },
    {
      name: 'Sara Blakely',
      time: '7/10/2025',
      text: 'Order Code: 92432',
      avatar: imgFrame2147229025,
      tags: ['Track Order', 'Business Help'],
    },
    {
      name: 'Kate Lively',
      time: '20/08/2025',
      text: 'Reminder: Your scheduled payme...',
      avatar: imgFrame2147229026,
    },
    {
      name: 'Jennifer Anniston',
      time: '17/05/2025',
      text: 'I will inform if you need it again!',
      avatar: imgFrame2147229027,
    },
  ]

  const bottomCards = [
    {
      title: 'AI-Assisted Replies',
      desc: 'Automated responses with AI assistance or manual reply management, seamlessly syncing your data through automation platforms like Make, Zapier, and n8n.',
      icon: imgGroup1,
    },
    {
      title: 'Mobile Apps',
      desc: 'Dedicated iOS and Android applications with targeted push notifications to any specific team members and real-time messaging.',
      icon: imgRiAppsFill,
    },
    {
      title: 'Advanced Team Management',
      desc: 'See which person in your team sent each message, along with multi-user roles, member-specific push notifications, automatic label assignment, and real-time collaboration tools for your entire team.',
      icon: imgFluentPeopleTeam32Filled,
    },
  ]

  const additionalFeatures = [
    {
      title: 'Unlimited Messaging',
      desc: 'Send unlimited WhatsApp messages from your own number with no daily limits or restrictions.',
      icon: 'unlimited-messaging-svg',
    },
    {
      title: 'Advanced Analytics',
      desc: 'Track delivery rates, open rates, response rates, and conversion metrics in real-time.',
      icon: 'advanced-analytics-svg',
    },
    {
      title: 'Conversation Labels',
      desc: 'Auto and manual conversation labeling for better organization and follow-up.',
      icon: 'conversation-labels-svg',
    },
    {
      title: 'Media, Voice & Attachments',
      desc: 'Send PDFs, photos, audios, videos, and other attachments through WhatsApp.',
      icon: 'media-attachments-svg',
    },
    {
      title: 'Scheduled Messages',
      desc: 'Schedule messages and set up automated follow-up sequences.',
      icon: 'scheduled-messages-svg',
    },
    {
      title: 'Keep Existing WABA Number',
      desc: 'Continue using your existing WhatsApp Business number and import up to 6 months of past conversations.',
      icon: 'waba-number-svg',
    },
    {
      title: 'Human Support',
      desc: 'Dedicated support team available via WhatsApp chat, email, and Zoom calls.',
      icon: 'human-support-svg',
    },
  ]

  return (
    <section id="features" className="scroll-mt-20 bg-white px-4 py-10 sm:px-6 sm:py-12 md:px-8 lg:px-16 lg:py-16">
      <div className="mx-auto flex w-full max-w-screen-xl flex-col items-center gap-8 text-center sm:gap-10 lg:gap-12">
        {/* Pill */}
        <div className="relative flex items-center gap-2 rounded-full bg-[#fafafa] px-3 py-1.5 text-xs font-medium uppercase tracking-[0.28px] text-[#1c2329] shadow-[inset_0px_1px_1px_rgba(26,32,50,0.1),inset_0px_1px_2px_rgba(26,32,50,0.05)] sm:px-4 sm:py-2">
          <img src={imgSparkles} alt="" className="h-5 w-5 sm:h-6 sm:w-6" />
          <span>Features</span>
        </div>

        {/* Heading */}
        <div className="space-y-2 px-2 sm:px-0">
          <h2 className="text-pretty text-[24px] font-semibold leading-[1.1] tracking-[-0.8px] text-[#1c2329] sm:text-[32px] sm:leading-[1.05] sm:tracking-[-1px] md:text-[40px] lg:text-[52px]">
            Everything you need
            <br />
            for WhatsApp automation
          </h2>
          <p className="text-pretty text-[14px] leading-[1.6] tracking-[-0.3px] text-[#656f68] sm:text-[16px] sm:leading-[1.7] sm:tracking-[-0.5px] md:text-[17px]">
            Powerful features designed for business communication, team collaboration, and growth.
          </p>
        </div>

        {/* Feature cards */}
        <div className="w-full rounded-2xl border border-[#f2f3f3] bg-[#fafaf9] p-2 sm:p-3 md:p-4 lg:p-5">
          <div className="grid grid-cols-1 gap-3 sm:gap-4 md:gap-5 lg:grid-cols-2 lg:gap-6">
            {/* Automation card */}
            <div className="rounded-xl border border-[#f3f3f2] bg-white p-4 sm:p-5 md:p-6 lg:p-8 shadow-[0px_1px_3px_rgba(0,0,0,0.04)]">
              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#f4fdf9] via-white to-[#e2f6ec]">
                <div className="relative mx-auto w-full max-w-[640px]">
                  <div className="aspect-[4/3] w-full sm:aspect-[5/3]">
                    <img
                      src="/Features2.png"
                      alt="Automation flow preview"
                      className="relative z-10 h-full w-full rounded-xl object-contain shadow-[0px_12px_32px_rgba(0,0,0,0.12)]"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>

              <div className="mt-4 grid grid-cols-[auto_1fr] items-start gap-3 text-left sm:mt-5 sm:gap-4 md:mt-6">
                <div className="flex h-9 w-9 shrink-0 items-center justify-center sm:h-10 sm:w-10 md:h-12 md:w-12">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    className="h-5 w-5 text-[#01cd74] sm:h-6 sm:w-6 md:h-7 md:w-7"
                    aria-hidden="true"
                  >
                    <path
                      fill="currentColor"
                      d="M17.002 6.998a25 25 0 0 0-3.54-2.952c1.377-.7 2.682-1.122 3.813-1.253c1.427-.165 2.482.139 3.137.794c.656.656.96 1.71.794 3.137c-.13 1.132-.552 2.436-1.253 3.814a25 25 0 0 0-2.951-3.54"
                    />
                    <path
                      fill="currentColor"
                      fillRule="evenodd"
                      d="M15.941 8.059a23 23 0 0 1 3.179 3.94a23 23 0 0 1-3.179 3.941a23 23 0 0 1-3.94 3.179a23 23 0 0 1-3.942-3.179A23 23 0 0 1 4.881 12A23 23 0 0 1 8.06 8.057A23 23 0 0 1 12 4.88a23 23 0 0 1 3.941 3.179M12 14.5a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5"
                      clipRule="evenodd"
                    />
                    <path
                      fill="currentColor"
                      d="M13.462 19.953A25 25 0 0 0 17.002 17a25 25 0 0 0 2.951-3.54c.701 1.378 1.123 2.682 1.253 3.813c.165 1.427-.138 2.482-.794 3.137c-.655.656-1.71.96-3.137.794c-1.131-.13-2.436-.551-3.813-1.252M6.999 17a25 25 0 0 0 3.54 2.953c-1.378.7-2.682 1.122-3.814 1.252c-1.427.165-2.48-.138-3.136-.794c-.656-.655-.96-1.71-.795-3.137c.13-1.131.552-2.435 1.253-3.813A25 25 0 0 0 7 17.001m-2.953-6.463A25 25 0 0 1 7 6.998a25 25 0 0 1 3.54-2.952c-1.378-.7-2.682-1.122-3.814-1.253c-1.427-.164-2.481.139-3.137.794c-.655.656-.959 1.71-.794 3.138c.13 1.131.552 2.435 1.253 3.813"
                    />
                  </svg>
                </div>
                <div className="min-w-0">
                  <h3 className="text-[17px] font-semibold tracking-[-0.5px] text-[#1c2329] sm:text-[19px] sm:tracking-[-0.6px] md:text-[20px]">
                    Smart Follow-ups
                  </h3>
                  <p className="mt-1.5 text-[14px] leading-[1.5] text-[#656f68] sm:mt-2 sm:text-[15px] sm:leading-[1.6] md:text-[16px]">
                    Easily choose how many follow-ups you want to send, and they will automatically be sent as long as the lead does not reply.
                  </p>
                </div>
              </div>
            </div>

            {/* Chats card */}
            <div className="rounded-xl border border-[#f3f3f2] bg-white p-4 sm:p-5 md:p-6 lg:p-8 shadow-[0px_1px_3px_rgba(0,0,0,0.04)]">
              <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-[#effaf4] via-white to-[#dff5ea]">
                <div className="relative mx-auto w-full max-w-[640px]">
                  <div className="aspect-[4/3] w-full sm:aspect-[5/3]">
                    <img
                      src="/Features1.png"
                      alt="Smart Bulk WhatsApp Campaign preview"
                      className="relative z-10 h-full w-full rounded-xl object-contain shadow-[0px_12px_32px_rgba(0,0,0,0.12)]"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>

              <div className="mt-4 grid grid-cols-[auto_1fr] items-start gap-3 text-left sm:mt-5 sm:gap-4 md:mt-6">
                <div className="flex h-9 w-9 shrink-0 items-center justify-center sm:h-10 sm:w-10 md:h-12 md:w-12">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 48 48"
                    className="h-5 w-5 text-[#01cd74] sm:h-6 sm:w-6 md:h-7 md:w-7"
                    aria-hidden="true"
                  >
                    <path
                      fill="currentColor"
                      fillRule="evenodd"
                      d="M25.5.5a2 2 0 0 0-2 2v3a2 2 0 1 0 4 0v-3a2 2 0 0 0-2-2m-17 21a2 2 0 1 1 0-4h3a2 2 0 1 1 0 4zm34 0a2 2 0 1 0 0-4h-3a2 2 0 1 0 0 4zM12.064 8.895a2 2 0 0 1 2.829-2.828l2.121 2.12a2 2 0 1 1-2.828 2.83zm26.87-2.828a2 2 0 0 1 0 2.828l-2.122 2.121a2 2 0 1 1-2.828-2.828l2.121-2.121a2 2 0 0 1 2.829 0M25.049 10.04a1.5 1.5 0 0 1 2.119.095l.003.003l.003.004l.01.01l.03.034l.1.117q.13.15.368.447c.319.4.785 1.008 1.398 1.874c1.225 1.73 3.042 4.491 5.446 8.656c2.405 4.164 3.887 7.117 4.773 9.045a41 41 0 0 1 .924 2.147a18 18 0 0 1 .254.687l.014.043l.005.014l.002.007v.002a1.5 1.5 0 0 1-2.85.935c-1.245.418-2.51.83-3.782 1.233a72 72 0 0 0-1.257-2.881a98 98 0 0 0-4.047-7.789a98 98 0 0 0-4.72-7.399a72 72 0 0 0-1.865-2.526c.985-.9 1.974-1.79 2.959-2.659a1.5 1.5 0 0 1 .113-2.099m5.81 25.93q.068.159.133.318c-2.04.625-4.07 1.224-6.032 1.786l.277 1.032a6.59 6.59 0 1 1-12.733 3.412l-.266-.992c-.98.25-1.82.463-2.49.63c-1.649.412-3.445-.144-4.503-1.582c-.38-.518-.805-1.13-1.147-1.724a19 19 0 0 1-.92-1.855c-.716-1.635-.3-3.469.882-4.691c2.61-2.7 8.892-9.116 15.704-15.464l.207.27c.335.442.822 1.098 1.419 1.944a95 95 0 0 1 4.574 7.17a95 95 0 0 1 3.922 7.546c.435.94.76 1.69.974 2.2Zm-14.75 4.546l.259.966a2.59 2.59 0 1 0 5.005-1.34l-.263-.982c-1.787.495-3.472.95-5.001 1.356"
                      clipRule="evenodd"
                    />
                  </svg>
                </div>
                <div className="min-w-0">
                  <h3 className="text-[17px] font-semibold tracking-[-0.5px] text-[#1c2329] sm:text-[19px] sm:tracking-[-0.6px] md:text-[20px]">Smart Bulk WhatsApp Campaign</h3>
                  <p className="mt-1.5 text-[14px] leading-[1.5] text-[#656f68] sm:mt-2 sm:text-[15px] sm:leading-[1.6] md:text-[16px]">
                    Smart scheduling and delivery optimization for large campaigns. Our system sends bulk messages safely, minimizing the risk of your business number being blocked by Meta.
                  </p>
                </div>
              </div>
            </div>

          </div>

          {/* Bottom row */}
          <div className="mt-3 grid grid-cols-1 gap-3 sm:gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-3 lg:gap-6">
            {bottomCards.map((card) => (
              <div
                key={card.title}
                className="rounded-xl border border-[#f3f3f2] bg-white p-4 text-left shadow-[0px_1px_3px_rgba(0,0,0,0.04)] sm:p-5 md:p-6"
              >
                <div className="relative h-12 w-12 rounded-full border border-[rgba(28,35,41,0.15)] sm:h-14 sm:w-14 md:h-16 md:w-16">
                  <div className="absolute left-1/2 top-1/2 h-8 w-8 -translate-x-1/2 -translate-y-1/2 sm:h-9 sm:w-9 md:h-10 md:w-10">
                    <img src={card.icon} alt="" className="h-full w-full object-contain" loading="lazy" />
                  </div>
                </div>
                <h3 className="mt-4 text-[17px] font-semibold tracking-[-0.5px] text-[#1c2329] sm:mt-5 sm:text-[18px] sm:tracking-[-0.6px] md:text-[20px]">{card.title}</h3>
                <p className="mt-2 text-[14px] leading-[1.5] text-[#656f68] sm:mt-3 sm:text-[15px] sm:leading-[1.6] md:text-[16px]">{card.desc}</p>
              </div>
            ))}
          </div>

          {/* Additional Features - Expandable */}
          {isExpanded && (
            <div className="mt-3 grid grid-cols-1 gap-3 sm:gap-4 md:grid-cols-2 md:gap-5 lg:grid-cols-3 lg:gap-6">
              {additionalFeatures.map((feature, index) => (
                <div
                  key={feature.title}
                  className="rounded-xl border border-[#f3f3f2] bg-white p-4 text-left shadow-[0px_1px_3px_rgba(0,0,0,0.04)] animate-fade-in-up sm:p-5 md:p-6"
                  style={{ animationDelay: `${index * 0.05}s` }}
                >
                  <div className="relative h-12 w-12 rounded-full border border-[rgba(28,35,41,0.15)] sm:h-14 sm:w-14 md:h-16 md:w-16">
                    <div className="absolute left-1/2 top-1/2 h-8 w-8 -translate-x-1/2 -translate-y-1/2 sm:h-9 sm:w-9 md:h-10 md:w-10">
                      {feature.icon === 'unlimited-messaging-svg' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-full w-full">
                          <path fill="#01CD74" d="M18 3a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4h-4.724l-4.762 2.857a1 1 0 0 1-1.508-.743L7 21v-2H6a4 4 0 0 1-3.995-3.8L2 15V7a4 4 0 0 1 4-4zm-4 9H8a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2m2-4H8a1 1 0 1 0 0 2h8a1 1 0 0 0 0-2" />
                        </svg>
                      ) : feature.icon === 'advanced-analytics-svg' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-full w-full">
                          <path fill="#01CD74" d="M20.5 0A3.5 3.5 0 0 0 17 3.5v17a3.5 3.5 0 0 0 7 0v-17A3.5 3.5 0 0 0 20.5 0M12 11a3.5 3.5 0 0 0-3.5 3.5v6a3.5 3.5 0 0 0 7 0v-6A3.5 3.5 0 0 0 12 11M0 20.5a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0" />
                        </svg>
                      ) : feature.icon === 'conversation-labels-svg' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-full w-full">
                          <path fill="#01CD74" d="M2.25 4.025A1.75 1.75 0 0 1 4.025 2.25l7.488.095a2.75 2.75 0 0 1 1.913.807l7.299 7.298c.423.423.798 1.034.952 1.687c.156.664.096 1.476-.529 2.1l-6.91 6.911c-.625.625-1.437.685-2.101.529a3.66 3.66 0 0 1-1.687-.952l-7.298-7.299a2.76 2.76 0 0 1-.807-1.913zm5.592 2.29a.75.75 0 0 0-1.06 1.06l.707.708a.75.75 0 0 0 1.06-1.061z" />
                        </svg>
                      ) : feature.icon === 'media-attachments-svg' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="h-full w-full">
                          <path fill="#01CD74" d="M46.5 23c0-2.018-.024-3.847-.066-5.5c-.704 0-1.592-.002-2.56-.012c-2.27-.023-5.043-.088-6.867-.263c-3.333-.32-5.924-2.976-6.245-6.325c-.175-1.825-.236-4.575-.254-6.823c-.008-.962-.009-1.845-.006-2.542Q28.862 1.501 27 1.5c-6.315 0-10.674.323-13.418.637c-2.895.33-5.093 2.531-5.413 5.431c-.207 1.875-.42 4.537-.549 8.168A13.3 13.3 0 0 1 12 15c6.958 0 13 5.44 13 12.636v8.728c0 3.117-1.133 5.905-2.984 8.063q2.254.071 4.984.073c6.315 0 10.674-.323 13.418-.637c2.896-.33 5.094-2.531 5.414-5.431c.325-2.954.668-7.861.668-15.432" />
                          <path fill="#01CD74" d="M33.508 4.052c.018 2.255.079 4.883.24 6.562c.188 1.958 1.683 3.446 3.546 3.625c1.68.161 4.333.226 6.61.25c.803.008 1.55.01 2.182.011c-.594-1.394-2.033-3.944-5.433-7.277c-3.203-3.14-5.694-4.571-7.152-5.21c-.001.598 0 1.295.007 2.04" />
                          <path fill="#01CD74" fillRule="evenodd" d="M6.792 18.833A10.76 10.76 0 0 1 12 17.5c5.688 0 10.5 4.43 10.5 10.136v8.728C22.5 42.07 17.688 46.5 12 46.5S1.5 42.07 1.5 36.364v-4.768c0-3.676 3.087-6.46 6.648-6.46s6.648 2.784 6.648 6.46v4.677a2.5 2.5 0 0 1-5 0v-4.677c0-.698-.627-1.46-1.648-1.46s-1.648.762-1.648 1.46v4.768c0 2.728 2.352 5.136 5.5 5.136s5.5-2.408 5.5-5.136v-8.728c0-2.728-2.352-5.136-5.5-5.136c-1.028 0-1.98.262-2.792.71a2.5 2.5 0 0 1-2.416-4.377" clipRule="evenodd" />
                        </svg>
                      ) : feature.icon === 'scheduled-messages-svg' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-full w-full">
                          <path fill="#01CD74" d="M17 10c.1 0 .19.01.28.01L4.39 4.58C3.73 4.31 3 4.79 3 5.51v3.71c0 .46.31.86.76.97L11 12l-7.24 1.81c-.45.11-.76.51-.76.97v3.71c0 .72.73 1.2 1.39.92L10 17.05V17c0-3.86 3.14-7 7-7" />
                          <path fill="#01CD74" d="M17 12c-2.76 0-5 2.24-5 5s2.24 5 5 5s5-2.24 5-5s-2.24-5-5-5m1.29 7l-1.65-1.65a.5.5 0 0 1-.15-.35v-2.5c0-.28.22-.5.5-.5s.5.22.5.5v2.29l1.5 1.5c.2.2.2.51 0 .71c-.19.2-.5.2-.7 0" />
                        </svg>
                      ) : feature.icon === 'waba-number-svg' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="h-full w-full">
                          <path fill="#01CD74" fillRule="evenodd" d="M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11s-4.925 11-11 11c-1.936 0-3.757-.5-5.338-1.38L1.4 22.6l.98-5.262A10.95 10.95 0 0 1 1 12m6.147-5.353c.654-.655 1.527-.713 1.998-.69c.435.02.776.272.984.564l.952 1.334a1.5 1.5 0 0 1-.16 1.932l-.674.673c.223.544.67 1.42 1.272 2.021s1.477 1.05 2.02 1.273l.675-.674a1.5 1.5 0 0 1 1.931-.16l1.335.951c.291.209.544.55.564.984c.022.471-.036 1.344-.69 1.999c-1.067 1.066-2.741 1.077-4.264.659c-1.55-.426-3.13-1.34-4.197-2.406c-1.065-1.066-1.98-2.646-2.406-4.197c-.418-1.523-.407-3.197.66-4.263" clipRule="evenodd" />
                        </svg>
                      ) : feature.icon === 'human-support-svg' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="h-full w-full">
                          <path fill="#01CD74" d="M9 11a7 7 0 1 1 14 0a1 1 0 1 0 2 0a9 9 0 1 0-14.385 7.212a9 9 0 0 0 3.558 1.602a2 2 0 1 0 .216-2A7 7 0 0 1 9 11m1 0a6 6 0 1 1 7.913 5.689A3 3 0 0 0 16 16c-.727 0-1.393.259-1.913.689A6 6 0 0 1 10 11m6 11a3 3 0 0 0 2.83-4h5.67a3.5 3.5 0 0 1 3.5 3.5v.5c0 2.393-1.523 4.417-3.685 5.793C22.141 29.177 19.198 30 16 30s-6.14-.823-8.315-2.207C5.523 26.417 4 24.393 4 22v-.5A3.5 3.5 0 0 1 7.5 18h1.359a10 10 0 0 0 4.662 2.69c.54.791 1.45 1.31 2.479 1.31" />
                        </svg>
                      ) : (
                        <img src={feature.icon} alt="" className="h-full w-full object-contain" />
                      )}
                    </div>
                  </div>
                  <h3 className="mt-4 text-[17px] font-semibold tracking-[-0.5px] text-[#1c2329] sm:mt-5 sm:text-[18px] sm:tracking-[-0.6px] md:text-[20px]">{feature.title}</h3>
                  <p className="mt-2 text-[14px] leading-[1.5] text-[#656f68] sm:mt-3 sm:text-[15px] sm:leading-[1.6] md:text-[16px]">{feature.desc}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* CTA */}
        <div className="mt-4 sm:mt-5 md:mt-6">
          <button
            onClick={() => {
              const next = !isExpanded
              if (next) {
                posthog?.capture('features_expanded')
              }
              setIsExpanded(next)
              // Smooth scroll to show expanded content
              if (!isExpanded) {
                setTimeout(() => {
                  const featuresSection = document.getElementById('features')
                  if (featuresSection) {
                    featuresSection.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
                  }
                }, 100)
              }
            }}
            className="w-full rounded-full border border-[#1c2329] px-6 py-2.5 text-[14px] font-semibold tracking-[-0.4px] text-[#1c2329] shadow-[0px_4px_8px_rgba(36,196,211,0.1)] transition duration-150 hover:-translate-y-0.5 hover:shadow-[0px_6px_12px_rgba(36,196,211,0.15)] sm:w-auto sm:px-8 sm:py-3 sm:text-[15px] sm:tracking-[-0.48px] md:px-10 md:py-4 md:text-[16px]"
          >
            {isExpanded ? 'Show Less Features' : 'View All Features'}
          </button>
        </div>
      </div>
    </section>
  )
}

export default Features
